{   
    "title":"Forgot Password",
    "label": {
        "userName": "User Name"
    },
    "cancelBtn":{
        "label": "Cancel"
    },
    "submitBtn":{
        "label":"Request Verification code"
    },
    "validationMessages":{
        "userName": "Username is required"
    },
    "placeHolder":{
        "username": "Enter UserName"
    },
    "toasterMessages":{
        "changePassword":{
            "success": "Password Changed Successfully",
            "failure":""
        },
        "otp":{
            "success": "OTP sent!",
            "failure": ""
        }
    }
}